import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, children, testId }) => (
  <div data-testid={testId} className="min-h-screen bg-cream px-5 py-10 text-ink sm:px-8 sm:py-16">
    <div className="mx-auto max-w-2xl">
      <Link
        data-testid="back-home-link"
        to="/"
        className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-ink/60 transition-colors hover:text-ink"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Alignment
      </Link>
      <p className="mt-10 font-condensed text-sm font-semibold uppercase tracking-[0.25em] text-ink/50">
        Alignment · Human Design for Business
      </p>
      <h1 className="mt-2 font-condensed text-4xl font-semibold uppercase leading-none tracking-tight sm:text-5xl">
        {title}
      </h1>
      <div className="mt-8 space-y-6 text-sm leading-relaxed text-ink/75">{children}</div>
      <p className="mt-12 border-t border-ink/15 pt-6 text-xs text-ink/50">
        Alignment © 2026 Dasha Love · For self-reflection and experimentation.
      </p>
    </div>
  </div>
);
